import { AppointmentFormService } from './appointment-form.service';
import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AppointmentService } from '../../shared/services/appointment.service';
import { SelectServiceComponent } from './select-service/select-service.component';
import { AppointmentTimeComponent } from './appointment-time/appointment-time.component';
import { Store } from '@ngrx/store';
import {
  IFooterSummary,
  IServiceAppointmentForm,
  ServiceAppointmentState
} from '../../store/service-appointment/service-appointment.reducer';
import { iif, Observable, Subject } from 'rxjs';
import { debounceTime, map, mergeMap, switchMap, take } from 'rxjs/operators';
import { SubscriptionList } from '../../shared/models/asp.types';
import * as util from '../../shared/services/util.service';
import * as fromActions from '../../store/service-appointment/service-appointment.actions';
import * as fromSelectors from '../../store/service-appointment/service-appointment.selectors';
import * as fromSettingSelector from '../../store/settings/settings.selectors';
import { AppointmentBookingSource, AppointmentType, IGeneralSettingsAppointmentRequest, IOpcodeRequest, IServiceAppointment } from '@signal/asp-data-commons';
import { SelectVehicleComponent } from '../shared/select-vehicle/select-vehicle.component';
import { YourInformationComponent } from './your-information/your-information.component';
import { BdcDashboardState } from '../../store/bdcdashboard/bdcdashboard.reducer';
import { selectAppointmentById, selectAppointmentsLoadedById } from '../../store/bdcdashboard/bdcdashboard.selectors';
import { DateTime } from 'luxon';
import { UpsertAppointment } from '../../store/bdcdashboard/bdcdashboard.actions';
import * as _ from 'lodash';
import { AlertService } from '../../shared/services/alert.service';
import { confirmConfig, GLOBAL_CONSTANT } from '../../shared/services/util.service';
import { SettingsState } from '../../store/settings/settings.reducer';
import * as fromSettingsActions from '../../store/settings/settings.actions';
import { Departments } from '../../shared/enums/departments.enum';
import { AspBannerService } from '../../shared/services/asp-banner.service';
import { SearchCustomersState } from '../../store/search-customers/search-customers.reducer';
import * as fromSearchCustomersActions from '../../store/search-customers/search-customers.actions';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Validators } from '@angular/forms';


@Component({
  selector: 'app-service-appointment',
  templateUrl: './service-appointment.component.html',
  styleUrls: ['./service-appointment.component.scss'],
})
export class ServiceAppointmentComponent implements OnInit, AfterViewInit, AfterContentChecked, OnDestroy {
  private readonly maxSubmissionAttempts = 3;
  isEditMode = false;
  isSubmitting = false;
  isFirstLoad = true;
  selectedIndex = 0;
  continueBtnTrans : string = 'testDrive.continue';
  continueBtnText: string[] = [this.continueBtnTrans, this.continueBtnTrans, this.continueBtnTrans, 'testDrive.submit', 'testDrive.submitting'];
  transport;
  isEditMode$: Observable<boolean>;
  serviceAppointmentFooterSummaries$: Observable<IFooterSummary[]>;
  toShowFooterAppointment: boolean = true;
  returnTo: string = 'bdc-dashboard';
  private lastOpcodeSelection: string[];
  allTransportation:any;
  department: string = Departments.SERVICE;
  vin:string = '';
  appointmentId:string = '';
  breadcrumbSteps: object[] = [
    { name: 'testDrive.vehicle', id: 0 },
    { name: 'testDrive.services', id: 1 },
    { name: 'testDrive.appointment', id: 2 },
    { name: 'testDrive.confirm', id: 3 }
  ];
  @ViewChild(SelectVehicleComponent, { static: false }) selectVehicleComponent: SelectVehicleComponent;
  @ViewChild(SelectServiceComponent, { static: false }) selectServiceComponent: SelectServiceComponent;
  @ViewChild(AppointmentTimeComponent, { static: false }) appointmentTimeComponent: AppointmentTimeComponent;
  @ViewChild(YourInformationComponent, { static: false }) yourInformationComponent: YourInformationComponent;

  private subs: SubscriptionList = {};
  private editDetails: { appointmentId: string };
  languageCd: string = 'en';
  formChanged=true;
  serviceOpcodesLoading:boolean;
  settings:IGeneralSettingsAppointmentRequest={} as IGeneralSettingsAppointmentRequest;
  signalDeeplinkId="";
  src="";
  submissionAttemptCount = 0;
  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly dialog: MatDialog,
    private readonly router: Router,
    private readonly appointmentService: AppointmentService,
    public readonly appointmentFormService: AppointmentFormService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly serviceAppointmentState: Store<ServiceAppointmentState>,
    private readonly searchCustomerStore:Store<SearchCustomersState>,
    private readonly dashboardState: Store<BdcDashboardState>,
    private alertService: AlertService,
    private settingsState: Store<SettingsState>,
    private bannerService: AspBannerService,
    private translate: TranslateService
  ) {
    if(this.translate.currentLang?.includes('es')){
      this.languageCd = 'es';
    }

    this.subs.query = this.activatedRoute.queryParams.subscribe(params => {
      if(params.id && params.src === "signal") {
        this.signalDeeplinkId = params.id;
        this.src = params.src;
      } else {
        this.editDetails = { appointmentId: params.id };
        this.isEditMode = !!this.editDetails.appointmentId;
      }
      if (params.navigateTo) {
        this.returnTo = params.navigateTo;
      }
      if (this.isEditMode) {
       
        this.setUpStoreForEdit();
      }
    });
    const obj = {
      department: this.department,
    }
    this.settingsState.dispatch(new fromSettingsActions.LoadSettings(obj));
  }
  
  canExit():Observable<boolean> { 
    let dialogRef;
    const result = new Subject<boolean>();
    dialogRef = this.dialog.open(ConfirmDialogComponent, confirmConfig);
    this.subs.dialogRef = dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') { }
      else if(event.action === 'close'){
        result.next(true);
        result.complete();
       }
       else{}
    });
  return result.asObservable(); 
  };

  formsNotEdited()
  {
    return this.formChanged;
  }

  valuesChanges(event)
  {
    if(!this.isSubmitting) {
      this.formChanged = event;
    }
  }

  markYourInformationFirstLoadConsumed(): void {
    this.isFirstLoad = false;
  }

  transportChanges(event) {
    if(event){
      this.checkAndUpdateAvailability(event);
    }
  }

  ngOnInit(): void {
    this.setupStore();
    this.subs.selectSettings = this.settingsState.select(fromSettingSelector.selectSettings).subscribe(data => {
      this.allTransportation = data?.transport?.transportOptions
      if (data && Object.entries(data).length) {
        this.settings.time = data.time;
        this.settings.portal = data.portal;
        this.settings.dealerInfo = data.dealerInfo;
        this.settings.isAspCrmIntegrationEnabled = data.isAspCrmIntegrationEnabled;
        this.settings.isAspDmsIntegrationEnabled = data.isAspDmsIntegrationEnabled;
        this.settings.isConsumerPortalEnabled = data.isConsumerPortalEnabled;
        this.settings.isServiceAccessible = data.isServiceAccessible;
      }
    })
    setTimeout(()=> {
      if (this.signalDeeplinkId) {
        this.serviceAppointmentState.dispatch(
        new fromActions.LoadServiceAppointmentFromSignalDeepLink({ signalDeeplinkId: this.signalDeeplinkId }));
      }
    }, 0);
  }

  ngAfterViewInit() {
    this.bannerService.show();
  }

  isValidTransport(){
    const valid = this.allTransportation?.filter(t => t.isActive)?.map(t => t.id)
    return valid?.includes(this.yourInformationComponent?.step?.value?.transport)
  }

  switchTab(tabIndex?) {
    // TODO fix for showing mandatory fields as errors
    // this.appointmentFormService.appointmentMainForm.updateValueAndValidity();
    if(this.selectedIndex === 0){
      this.serviceAppointmentState.dispatch(new fromActions.TriggerLoader());
    }
    if (this.toShowFooterAppointment) {
      if (tabIndex !== undefined && tabIndex >= 0) {
        setTimeout(() => {
          this.setSelectedIndex(tabIndex);
        });
      } else {
        if (!this.isValidForm()) {
          this.markAsTouched();
          return false;
        }
        setTimeout(() => {
          this.setSelectedIndex(this.selectedIndex + 1);
          if (this.selectedIndex === 4) {
            this.submitTheAppointment();
          }
        });
      }
    }
  }

  setSelectedIndex(index: number) {
    const prevIndex = this.selectedIndex;
    this.selectedIndex = index;
    this.serviceAppointmentState.dispatch(new fromActions.UpdateCurrentStep({ step: index }));
    if(index === 2){
      this.yourInformationComponent?.step?.controls?.transport?.setValidators([Validators.required])
    }
    if (prevIndex < index && index === 1) {
      this.subs.mileage = this.serviceAppointmentState.select(fromSelectors.selectVehicleFormMileage)
        .pipe(debounceTime(1000))
        .subscribe(data => {
          if (data) {
            this.onMileageChange(data);
          }
        });
    }

    if (index === 3) {
      this.bannerService.hideCarImage();
    } else if (index === 2) {
      this.checkAndUpdateAvailability();
      this.bannerService.showCarImage();
    } else {
      this.bannerService.showCarImage();
    }

  }

  onMileageChange(mileage: number) {
    const opcodeRequest: IOpcodeRequest = { mileage: +mileage};
    if(this.selectVehicleComponent.step.controls.make.value){
      opcodeRequest.make = this.selectVehicleComponent.step.controls.make.value?.toUpperCase();
      opcodeRequest.model = this.selectVehicleComponent.step.controls.model?.value;
      opcodeRequest.year = this.selectVehicleComponent.step.controls.year?.value?.toString();
    }
    if(this.selectVehicleComponent.step.controls.vin.value){
      opcodeRequest.vin = this.selectVehicleComponent.step.controls.vin.value;
    }
    this.serviceAppointmentState.dispatch(new fromActions.LoadServiceRequests({ opcodeRequest, countryCode:util.countryCd.toUpperCase() === 'USA' ? 'US' : 'MX', languageCode:this.languageCd }));
  }

  private checkAndUpdateAvailability(transportValue?) {
    this.subs.appointmentFormSub = this.serviceAppointmentState.select(fromSelectors.selectAppointmentForm)
      .pipe(take(1))
      .subscribe((appointment: IServiceAppointmentForm) => {
        this.transport = transportValue || appointment.customerForm.transport;
        this.vin = appointment.vehicleForm.vin ? appointment.vehicleForm.vin : '';
       this.appointmentId = appointment.appointmentId ? appointment.appointmentId : '';
        /* Need to fetch availability only when the opcode selection has changed */
        const currentOpcodeSelection = appointment.serviceForm?.selectedServices?.map(ss => ss.opcode);
        if (_.isEqual(this.lastOpcodeSelection, currentOpcodeSelection)) {
          return;
        }
        this.lastOpcodeSelection = currentOpcodeSelection;

        /* If so, recalculate the availability */
        const chosenDate = appointment.availabilityForm.availability.appointmentStartDate;
        const transport = transportValue || appointment.customerForm.transport;
        const advisorId = appointment.availabilityForm.availability.advisorId || '-1';
        if (!!chosenDate) {
          const date = DateTime.fromISO(chosenDate)
            .startOf('month')
            .toFormat('yyyy-MM-dd');
          this.serviceAppointmentState.dispatch(new fromActions.LoadAvailability(
            { date, advisorId, transport, vin:this.vin,appointmentId:this.appointmentId }));
        } else {
          this.serviceAppointmentState.dispatch(new fromActions.LoadAvailability(
            { date: "", advisorId, transport, vin:this.vin,appointmentId:this.appointmentId }
          ));
        }
      });
  }

  gotoBack() {
    setTimeout(() => {
      this.setSelectedIndex(this.selectedIndex - 1);
    });
  }

  get getDisclaimerText() {
    return this.translate.instant('testDrive.privacyPolicyTxt');
  }

  onConfirmation(t: any) {
    this.dashboardState.dispatch(new UpsertAppointment({ appointment: t.data }));

    const urlState = {...t.data};   
    const navigationExtras: NavigationExtras = {
      queryParams: {
        id: t.data.appointmentId,
        navigateTo: this.returnTo
      },
      state: urlState
    };
    this.router.navigate(['asp/bdc/service/confirm'],navigationExtras);
  }

  isValidForm() {
    if (this.selectedIndex === 0) {
      return this.selectVehicleComponent?.step.valid && this.yourInformationComponent?.step.valid;
    } else if (this.selectedIndex === 1) {
      /* check if the service opcodes are not loading and the form is valid*/ 
      this.serviceAppointmentState.select(fromSelectors.selectServiceOpcodesLoading).subscribe(data=>{
        this.serviceOpcodesLoading=data;
      });
      return  !this.serviceOpcodesLoading && this.selectServiceComponent?.step?.valid;
    } else if (this.selectedIndex === 2) {
      return this.appointmentTimeComponent?.step?.valid && this.yourInformationComponent?.step.valid;
    } else if (this.selectedIndex === 3) {
      return true;
    }
  }

  markAsTouched() {
    this.appointmentFormService.markStepAsTouched(this.selectedIndex);
  }

  checkNav(tabNo: number) {
    switch (tabNo) {
      case 0:
        return true;
      case 1:
        return this.areStepsValid(0);
      case 2:
        return this.areStepsValid(0, 1);
      case 3:
        return this.areStepsValid(0, 1, 2);
      default:
        return false;
    }
  }

  areStepsValid(...steps: number[]) {
    for (const step of steps) {
      if (!this.isStepValid(step)) {
        return false;
      }
    }
    return true;
  }

  isStepValid(step: number) {
    switch (step) {
      case 0:
        return this.selectVehicleComponent?.step.valid && this.yourInformationComponent?.step.valid;
      case 1:
        return this.selectServiceComponent?.step.valid;
      case 2:
        return this.appointmentTimeComponent?.step.valid;
      case 3:
        return true;
      default:
        return false;
    }
  }

  ngAfterContentChecked(): void {
    if (!this.changeDetector['destroyed']) {
      this.changeDetector.detectChanges();
    }
  }

  ngOnDestroy(): void {
    util.unsubscribeSubscriptions(this.subs);
    this.bannerService.update('');
    this.serviceAppointmentState.dispatch(new fromActions.ResetServiceAppointmentState());
    this.changeDetector.detach();
  }

  private submitTheAppointment() {
    this.isSubmitting = true;
    this.formChanged=true;
    this.submissionAttemptCount = 1;

    this.executeSubmissionAttempt();
  }

  private executeSubmissionAttempt() {
    const serviceAppointmentState$ = this.serviceAppointmentState.select(fromSelectors.selectServiceAppointmentFeature)
      .pipe(take(1));

    /* Create appointment observable */
    const createAppointment$ = serviceAppointmentState$.pipe(
      take(1),
      switchMap((serviceAppointmentFeature: ServiceAppointmentState) => {
        const payload = { ...this.appointmentFormService.getMainFormDataAsCreateReq(serviceAppointmentFeature), settings: this.settings };
        if(this.src === 'signal') {
          payload["appointmentBookingSource"] = AppointmentBookingSource.SIGNAL_CTA;
        }
        return this.appointmentService.create(payload);
      }
      ));

    /* Update appointment observable */
    const updateAppointment$ = serviceAppointmentState$.pipe(
      take(1),
      switchMap((serviceAppointmentFeature: ServiceAppointmentState) => {
        const payload = { ...this.appointmentFormService.getMainFormDataAsUpdateReq(serviceAppointmentFeature), settings: this.settings };
        return this.appointmentService.update(payload);
      }
      ));

    this.subs.appointmentCreateSub =
      this.isEditMode$.pipe(
        take(1),
        mergeMap((isEditMode: boolean) =>
          iif(() => !isEditMode,
            createAppointment$,
            updateAppointment$
          ))).subscribe(t => {
            this.submissionAttemptCount = 0;
            this.onConfirmation(t);
            this.isSubmitting = false;
          }, error => {
            this.handleSubmissionError(error);
          });
  }

  private handleSubmissionError(error: any) {
    const errorMessage = util.getAlertErrorMessage(error, GLOBAL_CONSTANT.errorMessage);

    if (this.submissionAttemptCount >= this.maxSubmissionAttempts) {
      this.isSubmitting = false;
      this.subs.submissionEscalationPopup = this.alertService.showEscalationAlert()
        .afterClosed()
        .subscribe(() => {
          this.submissionAttemptCount = 0;
          this.selectedIndex--;
        });
      return;
    }

    this.isSubmitting = false;
    this.subs.submissionRetryPopup = this.alertService.openRetryPopup(errorMessage)
      .pipe(take(1))
      .subscribe((shouldRetry) => {
        if (shouldRetry) {
          this.submissionAttemptCount++;
          this.isSubmitting = true;
          this.executeSubmissionAttempt();
          return;
        }

        this.submissionAttemptCount = 0;
        this.selectedIndex--;
      });
  }

  private openSingleButtonPopup(message: string) {
    return this.dialog.open(ConfirmDialogComponent, {
      data: {
        popupTitle: 'Alert!',
        popupBodyText: message,
        saveButton: 'teamManagement.ok',
        hideCancelButton: true
      }
    });
  }

  private setupStore() {
    if(this.returnTo !== 'bdc-dashboard'){
    this.searchCustomerStore.dispatch(new fromSearchCustomersActions.ClearCustomerSelection());
    }

    this.serviceAppointmentState.dispatch(new fromActions.LoadAvailableMileages());
    this.serviceAppointmentState.dispatch(new fromActions.LoadAvailabilityOptions());

    this.isEditMode$ = this.serviceAppointmentState.select(fromSelectors.selectIsEditMode);
    this.serviceAppointmentFooterSummaries$ = this.serviceAppointmentState.select(fromSelectors.selectServiceAppointmentFooterSummaries);

    this.subs.currentStepSub = this.serviceAppointmentState.select(fromSelectors.selectCurrentStep)
      .subscribe((currentStep: number) => this.selectedIndex = currentStep);
  }

  private setUpStoreForEdit() {
    const props = { appointmentId: this.editDetails.appointmentId };
    const isDashboardRoutePath =  this.editDetails.appointmentId && this.router.url.includes("navigateTo=service-dashboard") ? true :false;
    const selectAppointmentById$ = this.serviceAppointmentState.select(selectAppointmentById, props);
    const fetchAppointmentFromBackend$ = this.appointmentService
      .get(AppointmentType.SERVICE, this.editDetails.appointmentId)
      .pipe(map(r => r.data));
    this.subs.appointmentLoadSub = this.dashboardState.select(selectAppointmentsLoadedById, props).pipe(
      mergeMap((appointmentsLoaded: boolean) =>
        iif(() => appointmentsLoaded,
          selectAppointmentById$,
          fetchAppointmentFromBackend$
        ))).subscribe((appointment: IServiceAppointment) => {
          const date = DateTime.fromISO(appointment.appointmentStartDate)
            .startOf('month')
            .toFormat('yyyy-MM-dd');

          this.serviceAppointmentState.dispatch(
            new fromActions.EditServiceAppointment({ ...this.editDetails, email: appointment.emailAddress, appointment,isDashboardRoutePath }));
        }
        );
  }
  toShowFooterDetails(event) {
    this.toShowFooterAppointment = event;
    }
  }
